var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.72634 5.33331L7.99967 7.05998L6.27301 5.33331L5.33301 6.27331L7.05967 7.99998L5.33301 9.72665L6.27301 10.6666L7.99967 8.93998L9.72634 10.6666L10.6663 9.72665L8.93967 7.99998L10.6663 6.27331L9.72634 5.33331ZM7.99967 1.33331C4.31301 1.33331 1.33301 4.31331 1.33301 7.99998C1.33301 11.6866 4.31301 14.6666 7.99967 14.6666C11.6863 14.6666 14.6663 11.6866 14.6663 7.99998C14.6663 4.31331 11.6863 1.33331 7.99967 1.33331ZM7.99967 13.3333C5.05967 13.3333 2.66634 10.94 2.66634 7.99998C2.66634 5.05998 5.05967 2.66665 7.99967 2.66665C10.9397 2.66665 13.333 5.05998 13.333 7.99998C13.333 10.94 10.9397 13.3333 7.99967 13.3333Z",
    fill: "#FF675B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1341"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.4d0ada0b95a50c3f904c56e887bfdc2f.svg";
export { ForwardRef as ReactComponent };